/* External */
import { useHistory } from 'react-router';

/* Utils */
import { useEffect } from 'react';
import { REPORT_GA } from '../utils/constants';
import { getPath, Routes } from '../utils/router';
import { gaService } from '../services/gaService';

const getLabelLander = (pathname) => {
  switch (pathname) {
    case getPath(Routes.Private.Home): {
      return REPORT_GA.GA_EVENT_LABEL_HOME;
    }
    case getPath(Routes.Private.Live): {
      return REPORT_GA.GA_EVENT_LABEL_LIVE;
    }
    case getPath(Routes.Private.OnDemand): {
      return REPORT_GA.GA_EVENT_LABEL_ON_DEMAND;
    }
    case getPath(Routes.Private.Sports): {
      return REPORT_GA.GA_EVENT_LABEL_SPORTS;
    }
    case getPath(Routes.Private.Kids): {
      return REPORT_GA.GA_EVENT_LABEL_KIDS;
    }
    default: {
      return '';
    }
  }
};

export default function useAnalitycNavigation() {
  const history = useHistory();

  useEffect(() => {
    history.listen(({ pathname }) => {
      gaService.sendEvent({
        action: REPORT_GA.GA_EVENT_ACTION_PAGE_VIEW,
        label: pathname,
        category: REPORT_GA.GA_EVENT_CATEGORY_PAGE_NAVIGATION,
      });
      const label = getLabelLander(pathname);
      if (label) {
        gaService.sendEvent({
          action: REPORT_GA.GA_EVENT_ACTION_LANDER,
          label,
          category: REPORT_GA.GA_EVENT_CATEGORY_PAGE_NAVIGATION,
        });
      }
    });
  }, [history]);
}
